import { useState, useEffect } from "react";

function useDevice() {
  const [device, setDevice] = useState({
    isMobile: false,
    isTablet: false,
    isPC: false,
  });
  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      setDevice({
        isMobile: width <= 576,
        isTablet: width > 576 && width <= 992,
        isPC: width > 992,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return device;
}

export default useDevice;
